<template>
  <div
    v-show="showing"
    :style="`height:${height}`"
    class="full-width component-overlay"
  >
    <template v-if="componentData">
      <component
        :is="componentData.component"
        :componentData="componentData"
        :height="height"
        @close="hide"
        :behavior="behavior"
        :eventOwner="eventOwner"
        :parentMetas="parentMetas"
        :cid="cid"
        :mediaManagerRequestUrl="mediaManagerRequestUrl"
      >
      </component>
    </template>
    <div class="close-btn" v-if="showCloseButton">
      <q-btn @click="hide" icon="close" size="14px" round flat dense />
    </div>
  </div>
</template>

<script>
import mixin from "../d-card-mixins";
import DVirtualTourComponent from "./DVirtualTourComponent/DVirtualTourComponent.vue";
import DPdfViewer from "./DPdfViewer/DPdfViewer.vue";
import DFullScreenCarousel from "./DFullScreenCarousel/DFullScreenCarousel.vue";
export default {
  name: "DComponentOverlay",
  components: { DVirtualTourComponent, DPdfViewer, DFullScreenCarousel },
  mixins: [mixin],
  props: {
    height: {
      type: String,
      required: true,
    },
    behavior: {
      type: String,
      default: "agent",
    },
    eventOwner: {
      type: String,
      default: "agent",
    },
    parentMetas: {
      type: Object,
      require: false,
      default: () => {},
    },
    cid: {
      type: String,
      default: "cenora",
    },
    mediaManagerRequestUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      lcomponentData: null,
      lshowCloseButton: true,
      lshowing: false,
    };
  },
  mounted() {
    if (this.componentData && Object.values(this.componentData).length) {
      this.hide();
    }
  },
  methods: {
    show(componentData) {
      this.showing = true;
      if (componentData.closeButton !== undefined) {
        this.showCloseButton = componentData.closeButton;
      } else {
        this.showCloseButton = true;
      }
      this.componentData = componentData;
    },
    hide() {
      this.showing = false;
      this.showCloseButton = false;
      this.componentData = {};
      this.$emit("hide", null);
    },
  },
  computed: {
    showing: {
      get() {
        if (this.behavior === "agent") {
          return this.lshowing;
        } else {
          return this.$cardStore.get("componentOverlay.showing");
        }
      },
      set(val) {
        if (this.behavior === "agent") {
          this.lshowing = val;
        } else {
          this.$cardStore.set("componentOverlay.showing", val);
        }
      },
    },
    showCloseButton: {
      get() {
        if (this.behavior === "agent") {
          return this.lshowCloseButton;
        } else {
          return this.$cardStore.get("componentOverlay.showCloseButton");
        }
      },
      set(val) {
        if (this.behavior === "agent") {
          this.lshowCloseButton = val;
        } else {
          this.$cardStore.set("componentOverlay.showCloseButton", val);
        }
      },
    },
    componentData: {
      get() {
        if (this.behavior === "agent") {
          return this.lcomponentData;
        } else {
          return JSON.parse(
            this.$cardStore.get("componentOverlay.componentData")
          );
        }
      },
      set(val) {
        if (this.behavior === "agent") {
          this.lcomponentData = val;
        } else {
          this.$cardStore.set(
            "componentOverlay.componentData",
            JSON.stringify(val)
          );
        }
      },
    },
    currentSync: {
      get() {
        if (this.behavior === " agent") {
          return null;
        }
        return this.$meeting?.record?.record?.data?.sync?.currentInteraction;
      },
    },
  },
  watch: {
    currentSync(val) {
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.component-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  color: white;
  background: rgba(0, 0, 0, 0.3);
}
.close-btn {
  position: absolute;
  right: 8px;
  top: 12px;

  .q-btn {
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
}
</style>
